import React from "react";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { FormControlLabel, Checkbox } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { Grid } from "@material-ui/core";
import { max } from "moment";
const useStyles = makeStyles(customInputStyle);

export default function AgencyInfo({
  form,
  handleChange,
  handleChangeCross,
  agenciesList,
  countries = [],
  states = [],
  medicalLimits = [],
  CSLLimits = [],
  specialDiscounts = [],
  optionCross = [],
  buttonsSave,
}) {
  const classes = useStyles();
  return (
    <GridContainer xs={12} sm={12} md={8}>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Producer Code"
          inputProps={{
            name: "producercode",
            value: form?.producercode,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form?.subagency}
              onChange={handleChange}
              name="subagency"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Sub-Agency"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Master Agency"
          menuItems={agenciesList.map((a) => ({
            value: a.id,
            label: `${a.producer_code} - ${a.agency_name}`,
          }))}
          inputProps={{
            name: "masteragency",
            value: form?.masteragency,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Agency Name"
          inputProps={{
            name: "agencyname",
            value: form?.agencyname,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Contact Name"
          inputProps={{
            name: "contactname",
            value: form?.contactname,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Address"
          inputProps={{
            name: "address",
            value: form?.address,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="City"
          inputProps={{
            name: "city",
            value: form?.city,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Zip Code"
          inputProps={{
            name: "zipcode",
            value: form?.zipcode,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Country"
          menuItems={countries.map((c) => {
            let item = {
              value: c.id,
              label: c.name,
            };
            return item;
          })}
          inputProps={{
            name: "country",
            value: form?.country,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText={"State"}
          menuItems={
            states
              ? states
                  .filter((item) => item.country_id == form?.country)
                  .map((item) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })
              : []
          }
          error={null}
          formControlProps={{
            fullWidth: true,
            className: classes.customFormControlClasses,
          }}
          name="state_id"
          information={"Tooltip Text"}
          value={form?.state}
          onChange={(e) => handleChange(e)}
          inputProps={{
            required: true,
            name: "state",
            id: "state",
            value: form?.state,
            onChange: handleChange,
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Phone"
          inputProps={{
            name: "phone",
            value: form?.phone,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Fax"
          inputProps={{
            name: "fax",
            value: form?.fax,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Email"
          inputProps={{
            name: "email",
            value: form?.email,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="License Number"
          inputProps={{
            name: "licensenum",
            value: form?.licensenum,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="State Licensed"
          menuItems={states.map((s) => ({
            value: s.id,
            label: s.name,
          }))}
          inputProps={{
            name: "statelicensed",
            value: form?.statelicensed,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="E&O Policy Number"
          inputProps={{
            name: "eo_policy_number",
            value: form?.eo_policy_number,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Default Medical Limit"
          menuItems={medicalLimits.map((item) => {
            return {
              value: item.value === "none" ? "0" : item.value,
              label: item.name,
            };
          })}
          inputProps={{
            name: "medicallimit",
            value: form?.medicallimit,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Default CSL Limit"
          menuItems={CSLLimits.map((item) => ({
            value: item.name,
            label: item.name,
          }))}
          inputProps={{
            name: "csllimit",
            value: form?.csllimit,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Default Special Discount"
          menuItems={[
            { value: "", label: "-- Blank --" },
            ...specialDiscounts.map((item) => ({
              value: item.id,
              label: item.name,
            })),
          ]}
          inputProps={{
            name: "specialdiscount",
            value: form?.specialdiscount,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Number of DEC to print"
          inputProps={{
            name: "dec_to_print",
            value: form?.dec_to_print,
            onChange: handleChange,
            type: "number",
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Default Border Crossing"
          menuItems={[
            { value: "", label: "-- Blank --" },
            ...optionCross.map((option) => ({
              value: option.id,
              label: option.name,
            })),
          ]}
          inputProps={{
            name: "default_border_crossing",
            value: form?.default_border_crossing,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Expiration date of license"
          inputProps={{
            name: "expirationdatelicense",
            value: form?.expirationdatelicense,
            onChange: handleChange,
            type: "date",
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Expiration of E&O"
          inputProps={{
            name: "expirationdate_eo",
            value: form?.expirationdate_eo,
            onChange: handleChange,
            type: "date",
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Tax ID"
          inputProps={{
            name: "tax_id",
            value: form?.tax_id,
            onChange: handleChange,
            type: "text",
            maxLength: 9,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form?.only_card}
              onChange={handleChange}
              name="only_card"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Only System Will Charge"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form?.default_premium}
              onChange={handleChange}
              name="default_premium"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Premiere Coverage"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form?.kiosko}
              onChange={handleChange}
              name="kiosko"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Kiosk"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomSelect
          labelText="Agency Kiosk"
          menuItems={[
            { value: "", label: "-- Select --" },
            ...agenciesList.map((a) => ({
              value: a.id,
              label: `${a.producer_code} - ${a.agency_name}`,
            })),
          ]}
          inputProps={{
            name: "agency_kiosko",
            value: form?.agency_kiosko,
            onChange: handleChange,
          }}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {optionCross?.length > 0 && (
        <>
          <GridItem xs={12} sm={12}>
            <span>Available Border Crossings:</span>
          </GridItem>
          {optionCross?.map((crossing, index) => {
            return (
              <GridItem xs={12} sm={6} key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form?.[`border_${index + 1}`] || false}
                      onChange={handleChange}
                      name={`border_${index + 1}`}
                      color="primary"
                      className={classes.colorCheck}
                    />
                  }
                  label={crossing.name}
                />
              </GridItem>
            );
          })}
        </>
      )}
      {buttonsSave()}
    </GridContainer>
  );
}
